export function contains(stringValue, charValue) {
  return stringValue.indexOf(charValue) > -1;
}

export default function pressedKeyValidator(e, VALID_CHARS) {
  if (!e.key) {
    return false;
  }

  const invalidKey =
    e.key.length === 1 &&
    (!contains(VALID_CHARS, e.key) || (e.key === '.' && contains(e.target.value, '.')));

  if (invalidKey) {
    e.preventDefault();
  }

  return true;
}
